export enum CUSTOM_ERROR_CODES {
  INVALID_CLIENT = 'INVALID_CLIENT',
  UNSUPPORTED_CLIENT = 'UNSUPPORTED_CLIENT',
  INSUFFICIENT_CREDITS = 'INSUFFICIENT_CREDITS',
  NO_CREDITS = 'NO_CREDITS',
  INVALID_ACCESS_TOKEN = 'INVALID_ACCESS_TOKEN',
  ACCOUNT_DEACTIVATED = 'ACCOUNT_DEACTIVATED',
  ZOOM_CONNECTION_REQUIRED = 'ZOOM_CONNECTION_REQUIRED',
}
